<div class="dashboard-shell">
  @if (mobileSidebarOpen) {
    <button
      type="button"
      class="dashboard-shell__backdrop"
      aria-label="Close sidebar"
      (click)="mobileSidebarOpen = false"
    ></button>
  }

  <aside
    class="dashboard-shell__sidebar"
    [class.dashboard-shell__sidebar--collapsed]="sidebarCollapsed"
    [class.dashboard-shell__sidebar--mobile-open]="mobileSidebarOpen"
  >
    <app-dashboard-sidebar [collapsed]="sidebarCollapsed" />
  </aside>

  <div class="dashboard-shell__content">
    <app-dashboard-header
      [user]="user"
      [currentTime]="currentTimeLabel"
      (menuToggle)="handleMenuToggle()"
    />

    <main class="dashboard-content">
      <section class="dashboard-hero">
        <div class="dashboard-hero__copy">
          <p class="dashboard-hero__eyebrow">Live Overview</p>
          <h2>Dashboard</h2>
          <p class="dashboard-hero__text">
            Overview snapshot. The dashboard is currently using dummy data so we can shape the layout and chart behavior before the APIs are wired.
          </p>
        </div>

        <div class="dashboard-hero__meta">
          <div class="dashboard-hero__pill">
            <span>Session</span>
            <strong>Token verified</strong>
          </div>
          <div class="dashboard-hero__pill">
            <span>Updated</span>
            <strong>{{ currentTimeLabel }}</strong>
          </div>
        </div>
      </section>

      <section class="dashboard-stats">
        @for (stat of stats; track stat.id) {
          <article class="stat-card stat-card--{{ stat.tone }}">
            <p class="stat-card__label">{{ stat.label }}</p>
            <div class="stat-card__value">{{ stat.value }}</div>
            <div class="stat-card__delta">{{ stat.delta }}</div>
          </article>
        }
      </section>

      <section class="dashboard-charts">
        <article class="chart-card chart-card--wide">
          <div class="chart-card__header">
            <div>
              <p class="chart-card__eyebrow">Load Curve</p>
              <h3>Demand vs Generation</h3>
            </div>
            <div class="chart-card__chip">Dummy Data</div>
          </div>
          <div #loadChartContainer class="chart-card__body"></div>
        </article>

        <article class="chart-card">
          <div class="chart-card__header">
            <div>
              <p class="chart-card__eyebrow">Mix</p>
              <h3>Generation Mix</h3>
            </div>
            <div class="chart-card__chip">Current Share</div>
          </div>
          <div #mixChartContainer class="chart-card__body"></div>
        </article>
      </section>

      <section class="dashboard-secondary">
        <article class="panel-card">
          <div class="panel-card__header">
            <h3>Latest Events</h3>
            <span>Recent operational updates</span>
          </div>
          <div class="panel-card__list">
            @for (event of events; track event.id) {
              <div class="event-item event-item--{{ event.level }}">
                <div class="event-item__time">{{ event.time }}</div>
                <div class="event-item__copy">
                  <strong>{{ event.title }}</strong>
                  <p>{{ event.detail }}</p>
                </div>
              </div>
            }
          </div>
        </article>

        <article class="panel-card">
          <div class="panel-card__header">
            <h3>System Snapshot</h3>
            <span>Static KPIs until APIs arrive</span>
          </div>

          <div class="snapshot-grid">
            @for (card of summaryCards; track card.id) {
              <div class="snapshot-card">
                <p>{{ card.label }}</p>
                <strong>{{ card.value }}</strong>
                <span>{{ card.note }}</span>
              </div>
            }
          </div>
        </article>
      </section>
    </main>
  </div>
</div>
